import React from 'react'
import { Badge } from 'antd'

import CoreRenderFunction from 'DisplayCore'

const TechBaseBadge = props => {
  let {
    count = 0,
    config, 
    children
  } = props.item

  return(
    <Badge
      count={count}
      showZero={config.showZero}
      offset={config.offset}
      color={config.color}
    >
      {
        children?.map( child => <CoreRenderFunction {...props} item={ child } />)
      }
    </Badge>
  )
}

export default TechBaseBadge